import React, { Component } from "react";
import styled from "styled-components";
import { Icon, IconButton } from "@material-ui/core";

import { themeColors } from "js/react/sharedStyles";
import { AbsoluteBox, FlexBox } from "js/react/components/LayoutGrid";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import CustomImageStyleDialog from "js/react/views/AIGeneration/dialogs/CustomImageStyleDialog";
import { ImageStyleMenu, ImageStyleOption } from "js/react/views/AIGeneration/components/ImageStyleInput";
import { AiImageStyles, AiImageStyleTypes } from "common/aiConstants";
import { Popup, PopupPreview, PopupContent } from "js/Components/Popup";
import { Gap10 } from "js/react/components/Gap";

const ImageStyleContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
`;

const ImageStylePreview = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .MuiIconButton-root {
        opacity: 0;
        background: ${themeColors.ui_blue};
        color: white;
    }

    &:hover { 
        .MuiIconButton-root {
            opacity: 1;
            
            &:hover {
                background: #0e90c1;    
            }
        }
    }
`;

export class ThemeImageStyles extends Component {
    handleImageStyleChange = imageStyle => {
        if (imageStyle === "custom") {
            ShowDialog(CustomImageStyleDialog, {
                theme: this.props.theme,
                imageStyle: this.props.theme.imageStyle,
                imageStylePrompt: this.props.theme.imageStylePrompt,
                hideThemeImageStyle: true,
                onSuccess: (imageStyle, imageStylePrompt) => {
                    this.props.update({ imageStyle, imageStylePrompt });
                }
            });
        } else {
            const imageStylePrompt = AiImageStyles[imageStyle].prompt;
            this.props.update({ imageStyle, imageStylePrompt });
        }
    }

    render() {
        const imageStyle = this.props.theme.imageStyle || AiImageStyleTypes.MINIMALIST;

        return (
            <ImageStyleContainer>
                <Popup>
                    <PopupPreview>
                        <FlexBox vertical>
                            <ImageStylePreview>
                                <ImageStyleOption imageStyle={imageStyle} iconOnly />
                                <AbsoluteBox>
                                    <IconButton><Icon>edit</Icon></IconButton>
                                </AbsoluteBox>
                            </ImageStylePreview>
                            <Gap10 />
                            <ImageStyleOption imageStyle={imageStyle} labelOnly />
                        </FlexBox>
                    </PopupPreview>

                    <PopupContent>
                        {closePopup => (
                            <ImageStyleMenu
                                allowedImageStyles={["custom", ...Object.values(AiImageStyleTypes)]}
                                selectedImageStyle={imageStyle}
                                onImageStyleSelected={style => {
                                    this.handleImageStyleChange(style);
                                    closePopup();
                                }}
                            />
                        )}
                    </PopupContent>
                </Popup>
            </ImageStyleContainer>
        );
    }
}
